import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const AdminAuthContext = createContext();

// Auth uses httpOnly cookies set by the backend — no tokens in localStorage.
axios.defaults.withCredentials = true;

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  // Kept for API compatibility with existing callers; auth travels via httpOnly cookie.
  const authHeaders = useCallback(() => ({}), []);

  useEffect(() => {
    axios.get(`${API}/api/auth/me`)
      .then(r => setAdmin(r.data))
      .catch(() => setAdmin(null))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { email, password });
    setAdmin(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/api/auth/logout`, {});
    } catch (err) {
      console.error('Logout request failed:', err);
    }
    setAdmin(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, authHeaders }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
}
